import { DidomiUtils } from '../utils/DidomiUtils';
import { isAllowed } from './utils';
import { createCookieRepository } from '../repository/cookies';
import { createStorageRepository } from '../repository/storage';

const noop = () => {};

const init = async (website, locale, debug = false) => {
  if (!DidomiUtils.isAlreadyInitialized()) {
    if (debug) {
      global.isCMPDebugMode = true;
    }
    DidomiUtils.setDidomiConfig(website, locale);
    DidomiUtils.setDidomiEvents(website, locale);
    if (
      website === 'ED' &&
      locale === 'fr-MA' &&
      document.cookie.includes('AIE_DIDOMI_MA')
    ) {
      await DidomiUtils.loadDidomiMoroccoTest();
    } else {
      await DidomiUtils.loadDidomi();
    }
  }
};

const createChangeUserConsentObserver = () => {
  const callbacks = new Map();
  // DidomiUtils depends on initializing its callbacks property
  DidomiUtils.consentChangeCallbacks = callbacks;
  return {
    listenChangeUserConsent: cb => {
      const callbackToken = Symbol('callback token');
      callbacks.set(callbackToken, cb);
      return callbackToken;
    },
    stopListeningChangeUserConsent: callbackToken => {
      delete callbacks.delete(callbackToken);
    },
  };
};

const cmpClient = {
  cookie: createCookieRepository(),
  localStorage: createStorageRepository('localStorage'),
  sessionStorage: createStorageRepository('sessionStorage'),
};
const get = type => cmpClient[type];

const createSuccessCMPClient = () => {
  const changeUserConsentObserver = createChangeUserConsentObserver();
  const successCMPClient = {
    status: 'success',
    init: () => Promise.resolve(successCMPClient),
    get,
    ...changeUserConsentObserver,
  };
  return successCMPClient;
};

const failedCMPClient = {
  get,
  status: 'error',
  init: () => Promise.resolve(failedCMPClient),
  listenChangeUserConsent: noop,
  stopListeningChangeUserConsent: noop,
};

export const createStorageClient = (website, locale, debug = false) => {
  if (!DidomiUtils.isAlreadyInitialized()) {
    return {
      get,
      status: 'idle',
      init: () =>
        init(website, locale, debug)
          .then(createSuccessCMPClient)
          .catch(() => failedCMPClient),
      listenChangeUserConsent: noop,
      stopListeningChangeUserConsent: noop,
    };
  }
  return createSuccessCMPClient();
};

const onChangeUserCMP = cb => {
  DidomiUtils.setCallback(cb);
};

export { isAllowed, onChangeUserCMP, init };
